export const ModalChangePhotoTranslationsUk = {
  addPhoto: 'Додати фото',
  textPlaceholder: 'Напишіть  Ваше повідомлення...',
};
